<template>
  <v-dialog
    v-model="dialog"
    width="max-content"
    max-width="800px"
    content-class="elevation-0"
  >
    <v-card min-width="800px" class="pa-5 rounded-20">
      <v-row>
        <v-col>
          <strong class="title-font font-weight-bold"> Invoice Summary </strong>
        </v-col>
        <v-col align="end">
          <v-btn @click="dialog = false" icon small>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <span class="title-font">ID:</span>
          <span class="text-body-1 ml-2"> {{ invoice?.invoice_number }} </span>
        </v-col>
        <v-col>
          <span class="title-font mr-2">Paid:</span>
          <v-icon v-if="invoice?.paid" color="success">mdi-check-circle</v-icon>
          <v-icon v-if="invoice?.paid === false" color="error">
            mdi-close-circle
          </v-icon>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <span class="title-font mr-2">Issued: </span>
          <span class="text-body-1">{{
            invoice?.invoiced_at | luxon({ output: "short" })
          }}</span>
        </v-col>
        <v-col v-if="!invoice?.paid && invoice?.due_date">
          <span class="title-font mr-2">Due: </span>
          <span class="text-body-1">{{
            invoice?.due_date | luxon({ output: "short" })
          }}</span>
        </v-col>
      </v-row>

      <div class="d-flex justify-space-between title-font mt-5">
        <small>Description</small>
        <small>Quantity</small>
        <small>Amount</small>
      </div>

      <template v-for="item in invoiceItems">
        <v-divider class="my-3" :key="'spacer' + item.uid" />
        <div class="d-flex justify-space-between title-font" :key="item.uid">
          <h4 class="black--text ml-3">
            {{ capitalise(item.plan_code || item.product_code) }}
          </h4>
          <p class="mb-0">{{ item.quantity }}</p>
          <p class="mb-0">${{ item.unit_price }} {{ item.currency_code }}</p>
        </div>
      </template>

      <v-divider class="my-3" />

      <v-row class="mt-3">
        <v-col v-if="order && !selectedOrder && !arrears">
          <v-btn class="btn-primary mr-3" @click="openOrder" small>
            <v-icon class="mr-2">$inboxDark</v-icon>
            Open Order
          </v-btn>
        </v-col>
        <v-col>
          <div class="title-font text-right">
            <h3>
              Total: ${{ invoice?.amount }} {{ invoice?.currency }}
              <small>(ex Tax)</small>
            </h3>
          </div>
        </v-col>
      </v-row>

      <v-row v-if="order" class="mt-3">
        <v-col>
          <span class="title-font mr-2"> Order Number: </span>
          <span class="text-body-1"> {{ order?.order_number }} </span>
        </v-col>
        <v-col align="center">
          <span class="title-font mr-2"> Dentate: </span>
          <span class="text-body-1"> {{ capitalise(session?.dentate) }} </span>
        </v-col>
        <v-col align="end">
          <span class="title-font mr-2"> Session Type: </span>
          <span class="text-body-1"> {{ session?.session_type }} </span>
        </v-col>
      </v-row>

      <v-row v-if="order" class="mt-3">
        <v-col>
          <span class="title-font mr-2"> Client: </span>
          <span class="text-body-1"> {{ order?.client_name }} </span>
        </v-col>
        <v-col align="center">
          <span class="title-font mr-2"> Patient: </span>
          <span class="text-body-1"> {{ order?.patient_reference }} </span>
        </v-col>
      </v-row>

      <v-card-actions class="px-0 mt-5 pb-0">
        <v-spacer />
        <v-btn class="elevation-0 rounded-10 mr-3" @click="downloadPdf">
          <v-icon class="mr-2">mdi-download</v-icon>
          Download PDF
        </v-btn>
        <v-btn class="btn-primary" @click="openPaymentPage">
          <v-icon class="mr-2">mdi-link</v-icon>
          Open Payment Page
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import { capitalise } from "@/utils"
export default {
  props: ["value", "invoice", "arrears"],
  computed: {
    ...mapGetters(["inboxItems", "selectedOrder"]),

    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      }
    },

    invoiceItems() {
      return this.invoice?.items
    },

    order() {
      if (!this.invoice?.order_uid) return
      return this.inboxItems.find((i) => i.uid === this.invoice?.order_uid)
    },

    session() {
      if (!this.order) return
      return this.order?.sessions.find(
        (s) => s.uid === this.invoice?.order_session_uid
      )
    }
  },

  methods: {
    ...mapActions(["setSelectedOrder", "triggerReload"]),

    capitalise,

    downloadPdf() {
      window.open(this.invoice.pdf, "_blank")
    },

    openPaymentPage() {
      window.open(this.invoice.url, "_blank")
    },

    openOrder() {
      this.setSelectedOrder(this.order)
      this.triggerReload("order")
      this.$router.push({
        name: "caseView",
        query: {
          tab: "invoices"
        },
        params: {
          uid: this.invoice.order_uid,
          session_uid: this.invoice.order_session_uid
        }
      })
    }
  }
}
</script>
